import React, { useEffect } from 'react';
import { compose } from 'ramda';
import { makeStyles } from '@material-ui/core';
import { reduxForm, Form, Field, InjectedFormProps, isValid } from 'redux-form';
import Fields from 'components/Fields';
import { Button, BoxWrapper, Modal } from 'components/Base';
import Store from 'store/store';

const useStyles = makeStyles({
  paper: {
    minWidth: '20rem'
  },
  form: {
    padding: '1rem'
  },
  btnBox: {
    marginTop: '2rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  btn: {
    width: '45%'
  },
  field: {
    margin: '1rem 0'
  }
});

const { connect } = Store;

interface SaveAdvancedFilterModalProps {
  isModalOpen: boolean;
  isSaving: boolean;
  onClose: Function;
  values: any;
  isValid: boolean;
}

const SaveAdvancedFilterModal = ({
  handleSubmit,
  reset,
  isValid,
  isSaving,
  onClose,
  isModalOpen
}: InjectedFormProps & SaveAdvancedFilterModalProps) => {
  const classes = useStyles();

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  return (
    <Modal isOpen={isModalOpen} closeModalFunc={() => onClose()}>
      <BoxWrapper className={classes.paper} title="Save Filters">
        <Form onSubmit={handleSubmit} className={classes.form}>
          <Field
            name={`name`}
            fullWidth
            className={classes.field}
            validate={Fields.Validators.required}
            component={Fields.Text}
            label="Filter Name"
          />

          <div className={classes.btnBox}>
            <Button
              className={classes.btn}
              variant="contained"
              color="primary"
              disabled={isSaving}
              onClick={() => onClose()}
            >
              Cancel
            </Button>
            <Button
              className={classes.btn}
              variant="contained"
              disabled={!isValid}
              isLoading={isSaving}
              color="secondary"
              type="submit"
            >
              Save
            </Button>
          </div>
        </Form>
      </BoxWrapper>
    </Modal>
  );
};

export default compose(
  reduxForm({
    form: 'SaveAdvancedFilterModal'
  }),
  connect((state: any) => ({
    isValid: isValid('SaveAdvancedFilterModal')(state)
  }))
)(SaveAdvancedFilterModal);
